export default __webpack_public_path__ + "assets/front/scss/classification-browsing.df7f3334c0e4ee66628ca0d2155c9819.css";